module.exports = __webpack_public_path__ + "img/5.8923a7d2.jpg";